<template>
  <div class="editAccount">
    <!--新增-->
    <el-dialog
      :title="$t('account.editTitle')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="580px"
    >
      <el-form
        label-width="auto"
        ref="insertDialog"
        :inline="true"
        :label-position="'right'"
        :rules="rules"
        :model="addInfo"
      >
        <el-form-item :label="$t('account.userAcct')" prop="userAcct">
          <el-input
            v-model="addInfo.userName"
            class="inputWidth"
            :placeholder="$t('account.userAcctPlaceholder')"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('account.accountName')" prop="userAccount">
          <el-input
            v-model="addInfo.userAccount"
            class="inputWidth"
            :placeholder="$t('account.accountNamePlaceholder')"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('account.phone')" prop="phone">
          <el-input
            v-model="addInfo.phone"
            class="inputWidth"
            :placeholder="$t('account.phonePlaceholder')"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('account.email')" prop="email">
          <el-input
            v-model="addInfo.email"
            class="inputWidth"
            :placeholder="$t('account.emailPlaceholder')"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('account.sex')" prop="sex">
          <el-select
            :placeholder="$t('account.sexPlaceholder')"
            v-model="addInfo.sex"
            :disabled="true"
            filterable
          >
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('account.isAdmin')" prop="isAdmin">
          <el-select
            :placeholder="$t('account.isAdminPlaceholder')"
            v-model="addInfo.adminFlag"
            filterable
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('account.startValidityTime')" prop="startValidityTime">
          <el-date-picker
            v-model="addInfo.startValidityTime"
            type="date"
            class="inputWidth"
            value-format="yyyy-MM-dd"
            :placeholder="$t('account.startTimePlaceholder')"
            :picker-options="pickOptionBegin"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('account.endValidityTime')" prop="endValidityTime">
          <el-date-picker
            v-model="addInfo.endValidityTime"
            type="date"
            class="inputWidth"
            value-format="yyyy-MM-dd"
            :placeholder="$t('account.endTimePlaceholder')"
            :picker-options="pickOptionEnd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('account.remark')" prop="remark">
          <el-input
            type="textarea"
            :placeholder="$t('account.reamrkPlaceholder')"
            v-model="addInfo.remark"
            clearable
            style="width: 455px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
        <el-button @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from '@/api/systemManage/account.js';
  export default {
    name: 'editAccount',
    data() {
      return {
        dialogAdd: false,
        loading: false,
        userList: [],
        addInfo: {
          userAcct: null,
          userId: '',
          accountName: '',
          email: '',
          sex: '',
          startValidityTime: null,
          endValidityTime: null,
          remark: '',
        },
        pickOptionBegin: {
          disabledDate: (time) => {
            if (this.addInfo.endValidityTime) {
              return time.getTime() >= new Date(this.addInfo.endValidityTime).getTime();
            }
          },
        },
        pickOptionEnd: {
          disabledDate: (time) => {
            if (this.addInfo.startValidityTime) {
              return (
                time.getTime() <=
                new Date(this.addInfo.startValidityTime).getTime() - 3600 * 24 * 1000
              );
            }
          },
        },
      };
    },
    computed: {
      rules() {
        // 校验特殊字符
        var specialValidate = (rule, value, callback) => {
          var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          if (value && value.match(reg)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else {
            callback();
          }
        };
        return {
          remark: [
            {
              min: 1,
              max: 400,
              message: this.$t('menu.remarkWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
        };
      },
    },
    methods: {
      openDialog(flag, id) {
        if (this.$refs['insertDialog']) {
          this.$refs['insertDialog'].resetFields();
        }
        this.loading = false;
        this.dialogAdd = flag;
        //初始化页面数据
        this.getDetailInfo(id);
      },
      getDetailInfo(id) {
        this.$axios.get(API.GET_DETAIL_API + '/' + id).then((res) => {
          if (0 == res.data.code) {
            this.addInfo = res.data.data;
            this.addInfo.adminFlag = res.data.data.adminFlag.toString();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //保存
      addSure() {
        this.$refs.insertDialog.validate((valid) => {
          if (valid && !this.loading) {
            this.loading = true;
            if (this.addInfo.startValidityTime) {
              this.addInfo.startValidityTime = this.addInfo.startValidityTime.substr(0, 10);
            }
            if (this.addInfo.endValidityTime) {
              this.addInfo.endValidityTime = this.addInfo.endValidityTime.substr(0, 10);
            }
            this.addInfo.inoutFlag = 'I';
            this.$axios.post(API.UPDATE_ACCOUNT_API, this.addInfo).then((res) => {
              this.loading = false;
              if (0 != res.data.code) {
                this.$alert(res.data.msg);
              } else {
                this.dialogAdd = false;
                this.$emit('getData');
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .inputWidth {
    width: 170px !important;
  }
</style>
